interface BubbleTextProps {
  text: string;
}

const BubbleText: React.FC<BubbleTextProps> = ({ text }) => {
  return (
    <p className='bg-black bg-opacity-30 rounded-xl m-1 p-1 font-mono'>
      {text}
    </p>
  );
}

export default BubbleText;
